<template>
  <div class="pulse-page">

    <div class="pulse-report-section">
      <div v-if="pulseInfoList.length" class="report-card">
        <div class="report-card__title">脉诊信息</div>
        <div class="pulse-info-list">
          <div
            v-for="(item, index) in pulseInfoList"
            :key="`${item.hand || 'pulse'}-${index}`"
            class="pulse-info-card"
          >
            <div v-if="item.hand" class="pulse-info-card__tag">{{ item.hand }}</div>
            <div class="pulse-info-card__summary">
              <div v-if="item.heartRate" class="pulse-info-card__row">
                <span class="pulse-info-card__label">心率</span>
                <span class="pulse-info-card__value">{{ item.heartRate }}</span>
              </div>
              <div v-if="item.pulseType" class="pulse-info-card__row">
                <span class="pulse-info-card__label">脉象</span>
                <span class="pulse-info-card__value">{{ item.pulseType }}</span>
              </div>
              <div v-if="item.strength" class="pulse-info-card__row">
                <span class="pulse-info-card__label">脉力</span>
                <span class="pulse-info-card__value">{{ item.strength }}</span>
              </div>
              <div v-if="getPulsePathogenesis(item, index) !== '--'" class="pulse-info-card__row pulse-info-card__row--full">
                <span class="pulse-info-card__label">病机</span>
                <span class="pulse-info-card__value">{{ getPulsePathogenesis(item, index) }}</span>
              </div>
            </div>
            <div class="pulse-chart-list">
              <div
                v-for="chart in getPulseChartList(item, index)"
                :key="`${item.hand || 'pulse'}-${chart.key}`"
                class="pulse-chart-item"
              >
                <div :class="['pulse-chart-item__title', { 'pulse-chart-item__title--legend': chart.key === 'overall' }]">
                  <div class="pulse-chart-item__title-main">
                    <span class="pulse-chart-item__title-text">{{ chart.title }}</span>
                  </div>
                  <div v-if="chart.key === 'overall'" class="pulse-chart-legend">
                    <span class="pulse-chart-legend__title">3D图说明</span>
                    <div class="pulse-chart-legend__list">
                      <span class="pulse-chart-legend__item">
                        <span class="pulse-chart-legend__label">您本次测量象图</span>
                        <img
                          class="pulse-chart-legend__image"
                          :src="pulse3dLegendImages.current"
                          alt="您本次测量象图"
                        >
                      </span>
                      <span class="pulse-chart-legend__item">
                        <span class="pulse-chart-legend__label">健康人群平均脉象图</span>
                        <img
                          class="pulse-chart-legend__image"
                          :src="pulse3dLegendImages.average"
                          alt="健康人群平均脉象图"
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <iframe
                  class="pulse-chart-frame"
                  :src="chart.url"
                  :style="{ height: `${chart.height}px` }"
                  frameborder="0"
                  scrolling="auto"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
            <div class="pulse-position-list">
              <div
                v-for="position in getPulsePositionList(item, index)"
                :key="`${item.hand || 'pulse'}-${position.key}`"
                class="pulse-position-item"
              >
                <div class="pulse-position-item__head">
                  <span class="pulse-position-item__name">{{ position.name }}：</span>
                  <span class="pulse-position-item__value">{{ position.value }}</span>
                </div>
                <div class="pulse-position-item__analysis">
                  <span class="pulse-position-item__analysis-label">分析</span>
                  <span class="pulse-position-item__analysis-text">{{ position.analysis }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="channelUrl" class="report-card">
        <div class="report-card__title report-card__title--legend">
          <span>六经辩证</span>
          <div class="channel-legend">
            <span class="channel-legend__group">
              <span class="channel-legend__title">六经说明：</span>
              <span class="channel-legend__item">
                <span class="channel-legend__color channel-legend__color--abnormal"></span>
                <span>此经异常</span>
              </span>
              <span class="channel-legend__item">
                <span class="channel-legend__color channel-legend__color--normal"></span>
                <span>此经正常</span>
              </span>
            </span>
            <span class="channel-legend__group">
              <span class="channel-legend__title">辨证说明：</span>
              <span class="channel-legend__item">
                <span class="channel-legend__color channel-legend__color--healthy"></span>
                <span>健康</span>
              </span>
              <span class="channel-legend__item">
                <span class="channel-legend__color channel-legend__color--subhealthy"></span>
                <span>亚健康</span>
              </span>
              <span class="channel-legend__item">
                <span class="channel-legend__color channel-legend__color--ill"></span>
                <span>病态</span>
              </span>
              <span class="channel-legend__item">
                <span class="channel-legend__color channel-legend__color--severe"></span>
                <span>病态严重</span>
              </span>
            </span>
          </div>
        </div>
        <iframe class="pulse-frame" :src="channelUrl" frameborder="0" style="height: 450px;"></iframe>
        <div v-if="combinedReportData && combinedReportData.data && combinedReportData.data.mais && combinedReportData.data.channels" class="channel-summary">
          <div class="channel-summary__item channel-summary__item--inline" >
            <span class="channel-summary__label">病在：{{
              combinedReportData.data.channels.jueyin 
            || combinedReportData.data.channels.shaoyang
            || combinedReportData.data.channels.shaoyin
            || combinedReportData.data.channels.taiyang
            || combinedReportData.data.channels.taiyin
            || combinedReportData.data.channels.yangming
            || '无'
            }}</span>
          </div>
          <div class="channel-summary__item channel-summary__item--inline" v-if="combinedReportData.data.mais.desc.desc[0]">
            <span class="channel-summary__label">辩证：{{ combinedReportData.data.mais.desc.desc[0]  }}</span>
          </div>
          <div class="channel-summary__item" v-if="combinedReportData.data.mais.desc_detail_zy.desc_detail_zy[0]">
            <div class="channel-summary__label">辩证注释：</div>
            <div class="channel-summary__value channel-summary__value--paragraph">
              <p class="channel-summary__paragraph">
                {{ combinedReportData.data.mais.desc_detail_zy.desc_detail_zy[0] }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="qxjyUrl" class="report-card">
        <div class="report-card__title">气血津液</div>
        <iframe class="pulse-frame" :src="qxjyUrl" frameborder="0" style="height: 380px;"></iframe>
        <div class="channel-summary">
          <p class="channel-summary__paragraph channel-summary__paragraph--compact">{{ qxjySummaryText || '--' }}</p>
        </div>
        <div class="channel-summary">
          <div class="channel-summary__value channel-summary__value--paragraph">
            <p class="channel-summary__paragraph">{{ qxjySummaryDesc || '--' }}</p>
          </div>
        </div>
      </div>

      <div v-if="heresyUrl" class="report-card">
        <div class="report-card__title">邪性</div>
        <iframe class="pulse-frame" :src="heresyUrl" frameborder="0" style="height: 150px;"></iframe>
        <div class="channel-summary">
          <p class="channel-summary__paragraph channel-summary__paragraph--compact">
            {{ combinedReportData.data.mais.fever.text || '--' }}
          </p>
        </div>
        <!-- <div class="channel-summary">
          <div class="channel-summary__item">
            <div class="channel-summary__label">注释：</div>
            <div class="channel-summary__value channel-summary__value--paragraph">
              <p class="channel-summary__paragraph">{{ qxjySummaryDescZy || '--' }}</p>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="goods-section">
      <div class="section-heading goods-header">
        <div>
          <div class="section-title">商品推荐</div>
        </div>
      </div>

      <div v-if="goodsLoading" class="goods-empty">商品加载中...</div>

      <div v-else-if="goodsList.length" class="goods-grid">
        <div
          v-for="item in goodsList"
          :key="item.goodsId"
          class="goods-card"
          @click="handleGoodsClick(item)"
        >
          <div class="goods-image-wrap">
            <img :src="getGoodsImage(item.coverImage)" :alt="item.goodsName" class="goods-image">
          </div>
          <div class="goods-info">
            <div class="goods-name">{{ item.goodsName || '--' }}</div>
            <div class="goods-price-row">
              <span class="goods-price">￥{{ formatPrice(item.memberPrice || item.price) }}</span>
              <span v-if="item.linePrice" class="goods-line-price">￥{{ formatPrice(item.linePrice) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="goods-empty">暂无推荐商品</div>
    </div>

    <div v-if="detailReportUrl && type == 1" class="detail-report-section">
      <button type="button" class="detail-report-button" @click="handleViewDetailReport">查看详细报告</button>
    </div>
  </div>
</template>
<script>
import { getCodeProjectCg, getRecommendationListByRecord, getCombinedMaiReport, getMaiZFx } from '@/api/signUp'
export default {
  name: 'Pulse',
  computed: {
    goodsImageBaseUrl() {
      return (process.env.VUE_IMG_URL || 'https://cos.dexintangjiankang.cn').replace(/\/$/, '')
    },
    wechatMiniAppId() {
      return String(process.env.VUE_APP_WECHAT_MINI_APPID || '').trim()
    },
    wechatMiniPath() {
      return String(process.env.VUE_APP_WECHAT_MINI_PATH || '').trim()
    },
    wechatMiniEnvVersion() {
      return String(process.env.VUE_APP_WECHAT_MINI_ENV_VERSION || 'release').trim()
    },
    goodsIdsQuery() {
      return this.goodsList
        .map(item => item && item.goodsId)
        .filter(id => id !== undefined && id !== null && id !== '')
        .join(',')
    },
    qxjySummaryText() {
      const reportData = this.combinedReportData || {}
      const data = reportData.data || {}
      const mais = data.mais || {}
      const keys = ['blood', 'chill', 'dampness', 'fluids', 'humor', 'phlegm', 'qi', 'fever']

      return keys
        .map(key => mais[key])
        .filter(item => item && String(item.score) !== '200')
        .map(item => (item && item.text ? String(item.text).trim() : ''))
        .filter(Boolean)
        .join('、')
    },
    qxjySummaryDesc() {
      const reportData = this.combinedReportData || {}
      const data = reportData.data || {}
      const mais = data.mais || {}
      const keys = ['blood', 'chill', 'dampness', 'fluids', 'humor', 'phlegm', 'qi', 'fever']

      return keys
        .map(key => mais[key])
        .filter(item => item && String(item.score) !== '200')
        .map(item => (item && item.desc ? String(item.desc).trim() : ''))
        .filter(Boolean)
        .join('\n')
    },
      qxjySummaryDescZy() {
      const reportData = this.combinedReportData || {}
      const data = reportData.data || {}
      const mais = data.mais || {}
      const keys = ['blood', 'chill', 'dampness', 'fluids', 'humor', 'phlegm', 'qi', 'fever']

      return keys
        .map(key => mais[key])
        .filter(item => item && String(item.score) !== '200')
        .map(item => (item && item.desc_zy ? String(item.desc_zy).trim() : ''))
        .filter(Boolean)
        .join('\n')
    },
    detailReportUrl() {
      const reportUrl = this.getDetailReportUrl()
      return reportUrl ? String(reportUrl).trim() : ''
    }
  },
  data() {
    return {
      url: "",
      channelUrl: "",
      qxjyUrl: "",
      heresyUrl: "",
      clinicId: '',
      pulse3dLegendImages: {
        current: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAA0CAMAAAA+ExN3AAABmFBMVEUAAABxrUf7+/pzrkny9Oz49/Hy8eWBtlyLvGnv7dvspRztniDj6M75+fb7+vjwrUb317be6tXtkCjukj14sVB7s1TxuV2UwHSaxH2iyYaqzZGy0pz106K61qb22q3C27HK4LzS5MXwo2HxvGXywHTzvYH00JXdqB7tmCHEqSevqi/upjeVqznthDp+rELvlk3wsVbxp23ysXv448X57eDtpxjtpSjsgy/sgTDuj0n00Y5xrUeCrz6jtC7QuhftuwrtvgntuQzttw3tshDtsBJ3rkSYsjONsTnttA/FuR3tqxXbvBKutSjmvQy5tyLtrRPtqRbtoBy6tyPtpxivtintohvtrhPmvQ3tpRntnh3sqRbbuxLtmSDspBnEuB12rUSNsTrtlSPsphfslyHsmx7tjiftnR7ttRCYszTsqxTskiTshyvsjCnsohrshS3siSrskCaZszTtkSbtkyXsgTDtgy/toxt7r0LtlyKSsTftiivtjCnOsB7nvg3sgi6stirgqhvlqhmcsjKrqzC2qyy3sibXuxXhvRCRUe/OAAAAO3RSTlMAtQKyDwoWoJIg4NstBgS2RSbTv6unn4d+dWpgWlZPSkA2m5eIemfd29TMxMLBuq6lj4E3HOPTzcuzbhgjAkMAAAM6SURBVGjezdYHUxpBFADg5QQUUMHee+8t/TAd7A1FLFGIGlCDsUURFUvq3867I8dxt7d7Dskx+82beXvv3s4wMG946L/jXMMDfX3NLsQs1/OvomdDVsQkru3pzc3ZzZmgxIYYVDD0JU1JEWJOYfNnhZJHiDXDhymXh5cQA2bEltriaPQqegURlTQXIpaMFH/CtSGGWEuOTo4EkE4gkrm4HjGjcHBfcLp/CrEvn4vzEStaPxL0sDLW7Z0XF9sX2xgoOi0ouyzWAq1h7vxAVp7NsebanY4dh8PZWmtW/u05dsI7AkhhCDmLtZbsfUarM7waXhU5ButTv5+tPCzVMfACImuf0eJcSPek1WXlkK2+xbGgq9yCsqL8wO8/8B9A+EXn/nO73e4H6XWsB8Lv78lHWVBvX0naWNkQQFKeAST8LGZ7u/KLNI/UvnBx6B81mBQ6tha3BJAWFaAAgZ9V/fbu3n6ToL+3u6vj8SLoMumrRmT5OXy67/OStfk1ERwgpIzVtNzf3d2n9/7g9VRwlPEtU/beTQr2JvcgJqnkPupZFOLpcs2U8c1T9nrnRMtzyxBYBth7gPVg9655qlIbIuIqVc3X740R5ylymhBZjarZ/c4gtK/RVIfIGk2q7tHxSGQ8Mq4ABQjsrClCvO/miaoQWVGOuvv6rVF+8iR5BYjInKvu9rwxTCCYwTAX5GHt314Zx0sYlSJEVoX3+14bZ1N7VBoRWZ2Jx/wK/DUTmFGAQiARSCRmEqlnCCnLNcr935q/dA0ia8rB+2NT61PrIjhgoAiBZcU72v04j6vkEJGtlMfFXxrpVmOYLfRhxo1ObE5sQkxIGSPXNXuo9328WpkVEXEVvJbbWd+sLwUeBJAefKbfd6uHmbb/VvOabpeml6ZT4AEimQEk3Tr9flw1zA3UJZbXEhs1lpdX0F9icW6vaNe7C5E8H3uPIbxA8U7KGPr9YIZLrMwdCo2FxgSQpDP+jJN76PdjGS6xspjbYLEMl1hZ0CMKeoIQHoz8TspYXe/+Q5dYBugtsQzQWWIZoLPEMkBniWWAzhLLAPoSy8SoUJdYJkZFZ4llQJ6F9WHWWWIZQF9iTSygLbF/ABZ3EpLbLQrBAAAAAElFTkSuQmCC',
        average: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAA0CAMAAAA+ExN3AAABQVBMVEUAAAASAvf5+vpOqA/x9PT19/dUqxfY3ep9v0+EwlnD4a7s7fZdryNstjeRyGmr1Y7q8+QVBfcZCfceDvdQqRAjFPcqG/cxI/g5LPhDNvhMQPhYTfhyafmAePmNhfmblPm3256po/q1sPrBvfrKx/rc2vrk8Nzj4vsUBvFltC91u0RkWvhGky0wVYM6cVyWy3G93afQ58EWDecaGdhKnR4jL7kkNLFlW/ibzXjU6MYSAvdOqA8aGNgdIcsuT4s7c1g3amVBhj8hK74qRpgkNLFImCUXEOQxWH4nPaQ1YXIUB/ETBvBMoRlLoRlFjzI0YXFFjzM+fUw+fEsXDuQyWX8/fUwoPaUkM7JEjjJJmCYnPaUrR5ggKr4UCewTBPQgKr0bHNMVDegiMLcpQZ4YFN0eJccgKMEgKcAwVYM1Y25HlCzKf8AZAAAAOnRSTlMA+QPtDAjkKa2jTRLZxJFuF/fz7evn4dnPxbuvk4N2aF5YTD80IiAa9c24oc7LwYtVO+/j3dnXoYM2YOm+NAAAAuNJREFUaN7N1gdTWkEQAODjPSAUKSr2hr239OypxI4FpIiIijX9//+AbM68yHHl6Sjkvtnh9u27Y25gdmbJi7NC0Wm/f2aJGCs0TRk7ECdGshZt6mh5RQzkC+LVjL6jFaCclglimiitEwkTs8RsWi9gEZMsJ6hokRgk3kIl7CQxhjVDpfyfiClqWsXQtsZWUYl4SXN54z4iSgo3/F9tbcUiCWr7I9FkmCt/tKlOsHl3jD+0RCKw5HPKEwEsmHFHb4Tv1WgobpGJUNBPXQW9pCmCVGAnbPoo000ZKUI2fQZ/zMf/JcvJWMgizzTkqTU1R5/n7fy71+yL3ryfX5izKVqY8rjqJ2qjrVBrjb6ATOVXhtbYAze9ml96vIPbelmhjfAd9LrCmvbtBs4WbYh10GrXdJnVB7zU4WHmMMNggsGtyMmF1SE/fwsanhGiNgC8L9sPKtsVjG2RuMf9XUp3w0GiNuwBXjqbY7K5bPY0e4qRxTSXO8095PiB/tUx+Jr8/AoozRK1sTao83O9UdZApcdHlCY7oU41X8ozhXwBI4+PpVKhVMAoYcrqQo4f6D5Xn09dglznJFHy9QjbL1KN8xWk2saI2gcQ3H1unE15qwwTtUEPCH7s/XW0d8RggsFWB6Zi3cl156X/9ABRG5HcsHq8e7zLwQIj1qU17flrEPVZROlVO4iu1xqpDIJuzXwZ7gKJb5sy55vnGGJd3KN/dwf1OsaJktULMrfpP07SJwwmzFn6DCPtvMNwcmGP/nwReK2jRK0fpMpbMuWtMobwLNSR/vx1XTMPaYdYkKluKF1sXGDc51cbVxjSbfrzq8BxH2JFN6sNdvnEIVZUXGmw6hOHWNHNDlPcKTKYODBlzwLhnfZ89YlDrGj/4GD/YB+DrcjJpSvi9iHX848dYg3gNsQawGWINYDLEGsAlyHWANohdhYMoB9ijWgV7RBrxA1dhlgDuAyxBnAZYg2gH2I9JtANsb8BH2CfjrxDDw8AAAAASUVORK5CYII='
      },
      pulseInfoList: [],
      combinedReportData: null,
      pulseAnalysisData: null,
      goodsLoading: false,
      goodsList: [],
      fxParams:{},
      type: 1
    }
  },
  methods: {
    analysisUrl(url) {
      this.channelUrl = this.buildReportFrameUrl(url, { channel: true })
      this.qxjyUrl = this.buildReportFrameUrl(url, { qxjy: true })
      this.heresyUrl = this.buildReportFrameUrl(url, { heresy: true })
    },
    buildReportFrameUrl(url, extraParams) {
      const { mid, appId, accessSession } = this.parseUrlParams(url)

      if (!mid || !appId || !accessSession) {
        return ''
      }

      const query = new URLSearchParams({
        mid: String(mid),
        appId: String(appId),
        access_session: String(accessSession)
      })

      Object.keys(extraParams || {}).forEach(key => {
        const value = extraParams[key]

        if (value !== undefined && value !== null && value !== '') {
          query.set(key, String(value))
        }
      })

      return `https://hybrid.reborn-tech.com/report.html#/single?${query.toString()}`
    },
    parseUrlParams(url) {
      let hash = ''

      if (url) {
        const hashIndex = url.indexOf('#')
        if (hashIndex !== -1) {
          hash = url.substring(hashIndex)
        }
      } else {
        hash = window.location.hash
      }

      const queryString = hash
        .replace(/^#\/\?/, '')
        .replace(/^#\//, '')
        .replace(/^#\?/, '')
        .replace(/^#/, '')

      const params = new URLSearchParams(queryString)

      return {
        mid: params.get('mid'),
        appId: params.get('appId'),
        accessSession: params.get('access_session')
      }
    },
    fetchCombinedReport(sourceUrl) {
      const { mid, accessSession } = this.parseUrlParams(sourceUrl)

      if (!mid) {
        return Promise.reject(new Error('缺少必要参数：mid 未找到'))
      }

      if (!accessSession) {
        return Promise.reject(new Error('缺少必要参数：access_session 未找到'))
      }

      return getCombinedMaiReport(mid, accessSession, { silentError: true }).then(res => res.data )
    },
    fetchPulseAnalysis(params) {
      if (!this.hasPulseAnalysisInput(params)) {
        return Promise.resolve(null)
      }

      return getMaiZFx(params, { silentError: true }).then(res => {
        const responseData = res && res.data

        if (!responseData || String(responseData.code) !== '200') {
          throw new Error((responseData && responseData.msg) || '获取脉诊分析失败')
        }

        return responseData.data || null
      })
    },
    loadPulseAnalysis(params) {
      return this.fetchPulseAnalysis(params).then(data => {
        this.pulseAnalysisData = data || null
        return data
      }).catch(error => {
        this.pulseAnalysisData = null
        return Promise.reject(error)
      })
    },
    loadCombinedReport(sourceUrl) {
      return this.fetchCombinedReport(sourceUrl).then(data => {
        this.combinedReportData = data || null
        this.fxParams = this.buildFxParams(data)

        return this.loadPulseAnalysis(this.fxParams).catch(error => {
          console.error('获取脉诊分析失败：', error)
          return null
        }).then(() => data)
      }).catch(error => {
        this.combinedReportData = null
        this.pulseAnalysisData = null
        this.fxParams = {}
        console.error('获取组合报告失败：', error)
        return Promise.reject(error)
      })
    },
    getReportInfo(id) {
      if (!id) {
        return
      }
      getCodeProjectCg({
        id: id
      }, {
        silentError: true
      }).then(res => {
        if (String(res.data.code) === '200') {
          const reportData = res.data.data || {}
          this.clinicId = reportData && reportData.clinicId != null ? String(reportData.clinicId).trim() : ''
          this.pulseInfoList = this.parsePulseInfoList(reportData)
          this.url = reportData.result1Simple || reportData.result2Simple
          this.type = reportData.type
          if (this.url) {
            this.analysisUrl(this.url)
            this.loadCombinedReport(this.url).catch(() => {})
          }
        }
      })
    },
    getGoodsList(id) {
      if (!id) {
        return
      }
      this.goodsLoading = true
      getRecommendationListByRecord(Number(id), {
        silentError: true
      }).then(res => {
        if (String(res.data.code) === '200') {
          const data = res.data.data
          this.goodsList = Array.isArray(data) ? data : []
        } else {
          this.goodsList = []
        }
      }).catch(() => {
        this.goodsList = []
      }).finally(() => {
        this.goodsLoading = false
      })
    },
    formatPrice(price) {
      const num = Number(price)
      if (Number.isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    buildFxParams(reportData) {
      const data = (reportData && reportData.data) || {}
      const leftData = data.data_left || {}
      const rightData = data.data_right || {}

      return {
        left: this.buildFxSide(leftData),
        right: this.buildFxSide(rightData),
        flags: {
          left: leftData.flag || {},
          right: rightData.flag || {}
        }
      }
    },
    buildFxSide(sideData) {
      return {
        cun: this.buildFxPosition(sideData.cun),
        guan: this.buildFxPosition(sideData.guan),
        chi: this.buildFxPosition(sideData.chi)
      }
    },
    buildFxPosition(positionData) {
      const values = {
        shu: this.getNumericPulseValue(positionData && positionData.shu),
        hua: this.getNumericPulseValue(positionData && positionData.hua),
        xian: this.getNumericPulseValue(positionData && positionData.xian),
        fu: this.getNumericPulseValue(positionData && positionData.fu)
      }
      const pulses = this.getPulseTypeText(values)

      return {
        pulses: pulses === '--' ? '' : pulses.replace(/、/g, ','),
        values
      }
    },
    hasPulseAnalysisInput(params) {
      const positions = ['cun', 'guan', 'chi']
      const hands = ['left', 'right']

      return hands.some(hand => {
        const handData = params && params[hand]

        return positions.some(position => {
          const positionData = handData && handData[position]
          return !!(positionData && positionData.pulses)
        })
      })
    },
    getNumericPulseValue(value) {
      const numericValue = Number(value)
      return Number.isNaN(numericValue) ? 0 : numericValue
    },
    getPulsePositionList(item, index) {
      const positions = [
        { key: 'cun', name: '寸' },
        { key: 'guan', name: '关' },
        { key: 'chi', name: '尺' }
      ]
      const handData = this.getPulseHandData(item, index)
      const analysisHandData = this.getPulseAnalysisHandData(item, index)

      return positions.map(position => {
        const positionData = handData[position.key] || {}
        const positionAnalysisData = analysisHandData[position.key] || {}

        return {
          key: position.key,
          name: position.name,
          value: this.getPulseTypeText(positionData),
          analysis: this.getPulseInterpretation(positionAnalysisData)
        }
      })
    },
    getPulseChartList(item, index) {
      const handKey = this.resolvePulseHandKey(item, index)
      const isLeftHand = handKey === 'left'
      const chartList = [
        {
          key: 'overall',
          title: '总体脉象图',
          height: 360,
          url: this.buildReportFrameUrl(this.url, {
            overallLeft: isLeftHand,
            overallRight: !isLeftHand
          })
        }
      ]

      return chartList.filter(item => item.url)
    },
    resolvePulseHandKey(item, index) {
      const handText = item && item.hand ? String(item.hand) : ''

      if (handText.indexOf('左') !== -1) {
        return 'left'
      }

      if (handText.indexOf('右') !== -1) {
        return 'right'
      }

      return index === 0 ? 'left' : 'right'
    },
    getPulseHandData(item, index) {
      const reportData = this.combinedReportData || {}
      const data = reportData.data || {}
      const leftData = data.data_left || {}
      const rightData = data.data_right || {}
      return this.resolvePulseHandKey(item, index) === 'left' ? leftData : rightData
    },
    getPulseAnalysisHandData(item, index) {
      const analysisData = this.pulseAnalysisData || {}
      return this.resolvePulseHandKey(item, index) === 'left'
        ? (analysisData.left || {})
        : (analysisData.right || {})
    },
    getPulseInterpretation(positionAnalysisData) {
      const text = positionAnalysisData && positionAnalysisData.interpretations
      return text ? String(text).trim() : '--'
    },
    getPulsePathogenesis(item, index) {
      const analysisHandData = this.getPulseAnalysisHandData(item, index)
      const text = analysisHandData && analysisHandData.pathogenesis
      return text ? String(text).trim() : '--'
    },
    getPulseTypeText(positionData) {
      const pulseTypeMap = {
        xian: ['弦', '软'],
        hua: ['滑', '细'],
        fu: ['浮', '沉'],
        shu: ['数', '尺']
      }
      const pulseTypeOrder = ['xian', 'hua', 'fu', 'shu']

      return pulseTypeOrder.map(key => {
        return this.getPulseTypeLabel(pulseTypeMap[key], positionData[key])
      }).filter(Boolean).join('、') || '--'
    },
    getPulseTypeLabel(labels, score) {
      const value = Number(score)

      if (!labels || labels.length < 2 || Number.isNaN(value)) {
        return ''
      }

      if (value > 75) {
        return labels[0]
      }

      if (value < 25) {
        return labels[1]
      }

      return ''
    },
    parsePulseInfoList(data) {
      return ['result1', 'result2'].map(key => {
        const value = data[key]
        if (!value) {
          return null
        }
        try {
          const parsed = JSON.parse(value)
          return parsed && typeof parsed === 'object' ? parsed : null
        } catch (error) {
          return null
        }
      }).filter(item => item)
    },
    getDetailReportUrl() {
      const pulseInfoList = Array.isArray(this.pulseInfoList) ? this.pulseInfoList : []
      const reportItem = pulseInfoList.find(item => {
        if (!item || typeof item !== 'object') {
          return false
        }
        return item.result2Simple || item.resultSimple
      })

      return (reportItem && (reportItem.result2Simple || reportItem.resultSimple)) || this.url || ''
    },
    handleViewDetailReport() {
      const reportUrl = this.getDetailReportUrl()
      if (!reportUrl) {
        return
      }
      window.location.href = reportUrl
    },
    getGoodsImage(url) {
      if (!url) {
        return ''
      }
      const imageUrl = String(url).trim()
      if (/^(https?:)?\/\//i.test(imageUrl) || imageUrl.startsWith('data:')) {
        return imageUrl
      }
      return `${this.goodsImageBaseUrl}/${imageUrl.replace(/^\/+/, '')}`
    },
    buildGoodsJumpUrl(item) {
      const goodsId = item && item.goodsId
      const extraParams = this.clinicId ? `&pType=1&pId=${encodeURIComponent(this.clinicId)}` : ''
      const query = goodsId !== undefined && goodsId !== null && goodsId !== ''
        ? `goodsId=${encodeURIComponent(String(goodsId))}${extraParams}`
        : this.goodsIdsQuery
          ? `goodsIds=${encodeURIComponent(this.goodsIdsQuery)}`
          : ''

      if (!this.wechatMiniAppId || !this.wechatMiniPath || !query) {
        return ''
      }

      return `weixin://dl/business/?appid=${encodeURIComponent(this.wechatMiniAppId)}&path=${encodeURIComponent(this.wechatMiniPath)}&query=${encodeURIComponent(query)}&env_version=${encodeURIComponent(this.wechatMiniEnvVersion)}`
    },
    handleGoodsClick(item) {
      const goodsId = item && item.goodsId
      if (!goodsId) {
        return
      }
      if (window.wx && window.wx.miniProgram && typeof window.wx.miniProgram.navigateTo === 'function') {
        const extraParams = this.clinicId ? `&pType=1&pId=${encodeURIComponent(this.clinicId)}` : ''
        window.wx.miniProgram.navigateTo({
          url: `/pages/goods-detail/goods-detail?id=${goodsId}${extraParams}`
        })
      }
    }
  },
  mounted() {
    // 获取页面参数id
    this.getReportInfo(this.$route.query.id)
    this.getGoodsList(this.$route.query.id)
  }
}
</script>

<style scoped>
.pulse-page {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  max-width: 1280px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 20px 20px 32px;
  background: #f8fafc;
  color: #1f1f1f;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.pulse-report-section {
  grid-column: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 8px 28px 28px;
  border: 1px solid #e8edf5;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
}

.section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  position: relative;
  padding-left: 14px;
  font-size: 19px;
  font-weight: 700;
  color: #1f1f1f;
  line-height: 1.4;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 6px;
  height: 18px;
  border-radius: 999px;
  background: #b9413b;
  transform: translateY(-50%);
}

.report-card {
  overflow: hidden;
  border-bottom: 1px solid #e6dfd5;
  background: transparent;
}

.report-card:last-child {
  border-bottom: 0;
}

.report-card__title {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 0 14px;
  font-size: 19px;
  font-weight: 700;
  color: #1f1f1f;
}

.report-card__title--legend {
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.channel-legend {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  flex-wrap: wrap;
  font-size: 14px;
  font-weight: 400;
  color: #766f67;
}

.channel-legend__group {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.channel-legend__title {
  color: #3a342f;
  font-weight: 600;
}

.channel-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.channel-legend__color {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #d8d0c6;
}

.channel-legend__color--abnormal {
  background: #b9413b;
  border-color: #b9413b;
}

.channel-legend__color--normal {
  background: #f4f1eb;
  border-color: #d9d1c8;
}

.channel-legend__color--healthy {
  background: #5a7f66;
  border-color: #5a7f66;
}

.channel-legend__color--subhealthy {
  background: #bb9558;
  border-color: #bb9558;
}

.channel-legend__color--ill {
  background: #d9bf74;
  border-color: #d9bf74;
}

.channel-legend__color--severe {
  background: #b9413b;
  border-color: #b9413b;
}

.pulse-frame {
  display: block;
  width: 100%;
  border: 1px solid #eef2f7;
  border-radius: 18px;
  background: #fff;
  box-sizing: border-box;
}

.channel-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 28px;
  padding: 18px 0 24px;
}

.channel-summary__item {
  min-width: 0;
}

.channel-summary__item--inline {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.channel-summary__label {
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1.7;
  font-weight: 600;
  color: #262321;
}

.channel-summary__value {
  color: #49433e;
}

.channel-summary__value--paragraph {
  width: 100%;
  max-width: 100%;
  margin-top: 8px;
  box-sizing: border-box;
}

.channel-summary__paragraph {
  margin: 0;
  font-size: 15px;
  line-height: 1.9;
  color: #615a53;
  text-align: justify;
  white-space: pre-wrap;
  word-break: break-word;
}

.channel-summary__paragraph--compact {
  line-height: 1.75;
}

.pulse-info-list {
  display: flex;
  flex-direction: column;
  padding: 2px 0 18px;
}

.pulse-info-card {
  padding: 6px 0 10px;
}

.pulse-info-card + .pulse-info-card {
  margin-top: 8px;
  padding-top: 18px;
  border-top: 1px solid #e6dfd5;
}

.pulse-info-card__tag {
  display: inline-flex;
  align-items: center;
  margin-bottom: 14px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(185, 65, 59, 0.08);
  color: #b9413b;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
}

.pulse-info-card__summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.pulse-info-card__row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  min-height: 58px;
  padding: 14px 16px;
  border: 1px solid #edf2f7;
  border-radius: 16px;
  background: #f8fafc;
  font-size: 15px;
  line-height: 1.7;
  box-sizing: border-box;
}

.pulse-info-card__summary .pulse-info-card__row {
  width: 100%;
}

.pulse-info-card__row--full {
  grid-column: 1 / -1;
}

.pulse-info-card__label {
  flex: 0 0 auto;
  color: #64748b;
}

.pulse-info-card__value {
  flex: 0 1 auto;
  color: #0f172a;
  font-weight: 600;
  word-break: break-word;
}

.pulse-chart-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 18px;
}

.pulse-chart-item {
  min-width: 0;
  padding: 16px;
  border: 1px solid #edf2f7;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.pulse-chart-item__title {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  margin-bottom: 12px;
}

.pulse-chart-item__title--legend {
  gap: 10px;
}

.pulse-chart-item__title-main {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pulse-chart-item__title-text {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  color: #1f2937;
}

.pulse-chart-legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border: 1px solid #edf2f7;
  border-radius: 14px;
  background: #f8fafc;
  font-size: 13px;
  color: #6f675f;
}

.pulse-chart-legend__title {
  color: #5e564f;
  font-weight: 600;
}

.pulse-chart-legend__list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pulse-chart-legend__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  flex: 1 1 240px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #ffffff;
}

.pulse-chart-legend__label {
  min-width: 0;
  line-height: 1.5;
  color: #4f4841;
}

.pulse-chart-legend__image {
  width: 64px;
  height: auto;
  display: block;
  border: 1px solid #e6dfd5;
  border-radius: 6px;
  background: #fff;
  object-fit: contain;
  flex-shrink: 0;
}

.pulse-chart-frame {
  display: block;
  width: 100%;
  overflow: auto;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  background: #fff;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  box-sizing: border-box;
}

.pulse-position-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 18px;
  padding-bottom: 2px;
}

.pulse-position-item {
  padding: 16px 18px;
  border: 1px solid #edf2f7;
  border-radius: 16px;
  background: #f8fafc;
}

.pulse-position-item__head {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.pulse-position-item__name {
  color: #475569;
  font-size: 15px;
  font-weight: 700;
}

.pulse-position-item__value {
  flex: 1;
  min-width: 0;
  font-size: 17px;
  font-weight: 600;
  color: #0f172a;
  word-break: break-word;
}

.pulse-position-item__analysis {
  margin-top: 10px;
}

.pulse-position-item__analysis-label {
  display: inline-flex;
  align-items: center;
  margin-bottom: 6px;
  color: #5e564f;
  font-size: 13px;
  font-weight: 600;
}

.pulse-position-item__analysis-text {
  display: block;
  font-size: 14px;
  line-height: 1.75;
  color: #6d655e;
  word-break: break-word;
}

.goods-section {
  grid-column: 2;
  grid-row: 1 / span 2;
  position: sticky;
  top: 20px;
  align-self: start;
  padding: 22px 22px 24px;
  border: 1px solid #e8edf5;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
}

.detail-report-section {
  grid-column: 1;
  display: flex;
  justify-content: flex-start;
  padding-left: 28px;
}

.detail-report-button {
  min-width: 220px;
  padding: 14px 28px;
  border: 1px solid #2f6bff;
  border-radius: 999px;
  background: #2f6bff;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 10px 20px rgba(47, 107, 255, 0.18);
}

.detail-report-button:focus {
  outline: none;
}

.detail-report-button:hover {
  background: #fff;
  color: #2f6bff;
}

.goods-header {
  margin-bottom: 0;
  padding-bottom: 16px;
}

.goods-header .section-title {
  padding-left: 0;
}

.goods-header .section-title::before {
  display: none;
}

.goods-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
}

.goods-card {
  display: flex;
  gap: 12px;
  padding: 16px 0;
  cursor: pointer;
  border-bottom: 1px solid #e6dfd5;
  transition: opacity 0.2s ease;
}

.goods-card:hover {
  opacity: 0.85;
}

.goods-card:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.goods-image-wrap {
  width: 92px;
  height: 92px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #f1ece6;
}

.goods-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.goods-info {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.goods-name {
  font-size: 17px;
  font-weight: 600;
  color: #23201e;
  line-height: 1.5;
  word-break: break-word;
}

.goods-price-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 12px;
}

.goods-price {
  font-size: 21px;
  font-weight: 700;
  color: #b9413b;
}

.goods-line-price {
  font-size: 14px;
  color: #a59b90;
  text-decoration: line-through;
}

.goods-empty {
  padding: 28px 0 0;
  text-align: left;
  font-size: 15px;
  color: #8b847b;
}

@media (max-width: 1200px) {
  .pulse-page {
    grid-template-columns: minmax(0, 1fr);
  }

  .pulse-report-section,
  .goods-section,
  .detail-report-section {
    grid-column: auto;
    grid-row: auto;
  }

  .goods-section {
    position: static;
    top: 0;
  }

  .goods-grid {
    flex-direction: row;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;
  }

  .goods-card {
    flex: 0 0 280px;
    margin-right: 16px;
    padding-right: 16px;
    border-right: 1px solid #e6dfd5;
    border-bottom: 0;
    scroll-snap-align: start;
  }

  .goods-card:last-child {
    margin-right: 0;
    padding-right: 0;
    border-right: 0;
  }

  .detail-report-section {
    padding-left: 0;
  }
}

@media (max-width: 768px) {
  .pulse-page {
    padding: 16px 12px 24px;
  }

  .pulse-report-section,
  .goods-section {
    padding: 8px 16px 18px;
    border-radius: 18px;
  }

  .detail-report-button {
    width: 100%;
    min-width: 0;
  }

  .goods-card {
    flex-basis: 240px;
  }

  .pulse-frame {
    height: 1100px;
  }

  .channel-legend {
    width: 100%;
    justify-content: flex-start;
    gap: 12px;
  }

  .channel-summary {
    padding: 14px 0 18px;
  }

  .channel-summary__item,
  .channel-summary__item--inline {
    width: 100%;
  }

  .channel-summary__item--inline {
    justify-content: space-between;
  }

  .pulse-info-card__summary,
  .pulse-position-list,
  .pulse-chart-list {
    grid-template-columns: minmax(0, 1fr);
  }

  .report-card__title {
    padding: 16px 0 12px;
  }

  .pulse-info-card__row,
  .pulse-position-item,
  .pulse-chart-item {
    border-radius: 14px;
  }

  .pulse-chart-item {
    padding: 12px;
  }

  .pulse-chart-legend {
    padding: 10px;
    gap: 8px;
  }

  .pulse-chart-legend__list {
    flex-direction: column;
    gap: 8px;
  }

  .pulse-chart-legend__item {
    flex-basis: auto;
    padding: 8px 10px;
  }

  .pulse-chart-legend__label {
    font-size: 12px;
  }

  .pulse-chart-legend__image {
    width: 56px;
  }
}
</style>
